import { tv } from 'tailwind-variants';

const spinnerLoaderContainer = tv({
  base: 'flex justify-center',
});

const spinnerLoaderOuterRingBox = tv({
  base: 'relative w-10 h-10',
});

const spinnerLoaderOuterRing = tv({
  base: 'w-10 h-10 rounded-full absolute border-4 border-gray-200',
  variants: {
    borderStyle: {
      dashed: 'border-dashed',
      solid: 'border-solid',
      dotted: 'border-dotted',
    },
  },
  defaultVariants: {
    borderStyle: 'dashed',
  },
});

const spinnerLoaderInnerRing = tv({
  base: 'w-10 h-10 rounded-full animate-spin absolute border-4',
  variants: {
    color: {
      primary: 'border-primary-one border-t-transparent',
      secondary: 'border-secondary-one border-t-transparent',
      'secondary-dark': 'border-secondary-two border-t-transparent',
    },
    borderStyle: {
      dashed: 'border-dashed',
      solid: 'border-solid',
      dotted: 'border-dotted',
    },
  },
  defaultVariants: {
    color: 'primary',
    borderStyle: 'dashed',
  },
});

export const spinnerLoaderStyle = {
  container: spinnerLoaderContainer,
  outerRingBox: spinnerLoaderOuterRingBox,
  outerRing: spinnerLoaderOuterRing,
  innerRing: spinnerLoaderInnerRing,
};
